import React from "react";
import styles from "./hero.module.scss";

export const ContactusHero = () => {
  return (
    <>
      <section className={styles.section_contactus_hero}>
        <div className="container">
          <div className={styles.title_wrapper}>
            <h1 className={styles.title}>
              <span className="mark">Contact Us</span>
            </h1>
            <p className={styles.sub_text}>
              Get in touch with your questions or concerns about studying
              abroad, what we do, and how we can help!
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactusHero;
